import TableProducts from './TableProducts'

export default TableProducts;